// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__1VJyz","savePackageButton":"ClientWallet_savePackageButton__wwr6W"};